module.exports = __webpack_public_path__ + "json/market3-0.json?1f7bffc3b2c931a0fc90b76af846c365";


//////////////////
// WEBPACK FOOTER
// ./src/assets/packed/market/market3-0.json
// module id = 1264
// module chunks = 3